<template>
  <div class="confirmation-modal d-flex flex-column gap-4">
    <div
      v-if="config.heading || config.headingIcon"
      class="confirmation-modal-header"
      :class="{
        'text-red': config.headingColor === 'red',
        'd-flex justify-content-center':
          !config.headerPlacement || config.headerPlacement === 'center',
        'd-flex justify-content-between': config.headerPlacement === 'between',
        'd-flex justify-content-end': config.headerPlacement === 'end',
        'd-flex justify-content-start': config.headerPlacement === 'start'
      }"
    >
      <div v-if="config.headingIcon" class="header-icon">
        <i :class="config.headingIcon"></i>
      </div>
      <h3 v-if="config.heading" class="text-center m-0">
        {{ config.heading }}
      </h3>
    </div>

    <div class="confirmation-modal-body">
      <p v-if="config.body" v-html="config.body"></p>
    </div>

    <div
      :class="{
        'd-flex justify-content-center align-content-center gap-4':
          !config.buttonPlacement || config.buttonPlacement === 'center',
        'd-flex justify-content-between': config.buttonPlacement === 'between',
        'd-flex justify-content-end gap-3': config.buttonPlacement === 'end',
        'd-flex justify-content-start gap-3': config.buttonPlacement === 'start'
      }"
    >
      <BaseButton
        v-if="config.showCancelButton !== false"
        rounded
        :solid="config.cancelButtonSolid !== false"
        @click="onCancel"
      >
        {{ config.cancelButtonText || "Cancel" }}
      </BaseButton>

      <BaseButton
        v-if="config.showConfirmButton !== false"
        rounded
        :solid="config.confirmButtonSolid !== false"
        @click="onConfirm"
      >
        {{ config.confirmButtonText || "Confirm" }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import { onMounted, onUnmounted } from "vue"
import BaseButton from "@/v3components/shared/Buttons/BaseButton.vue"

export default {
  name: "ConfirmationModal",
  components: {
    BaseButton
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    onConfirmAction: {
      type: Function,
      default: () => ({})
    },
    onCancelAction: {
      type: Function,
      default: () => ({})
    }
  },
  emits: ["cancel"],
  setup(props, { emit }) {
    const onConfirm = () => {
      props.onConfirmAction()
      emit("cancel")
    }

    const onCancel = () => {
      props.onCancelAction()
      emit("cancel")
    }

    const handleEscKey = (event) => {
      if (event.key === "Escape") {
        onCancel()
      }
    }

    onMounted(() => {
      document.addEventListener("keydown", handleEscKey)
    })

    onUnmounted(() => {
      document.removeEventListener("keydown", handleEscKey)
    })

    return {
      onConfirm,
      onCancel
    }
  }
}
</script>

<style scoped>
.confirmation-modal {
  margin-top: -40px;
  width: 100%;
}

i {
  font-size: 1.5rem;
}
</style>
